import { scrollRef } from '@/features/chats/ui/Conversation/conversationRefs';
import { getUserIdFromJid } from '@/shared/utils';
import { useCallback } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { clearHighlightedMessageId, setHighlightedMessageId } from '../model/conversation/reducer';
import { useDraft } from '../model/draft/hooks';
import { useRepliedMessageById } from '../model/repliedMessages/selectors';

export const useReplyMessage = (options = {}) => {
   const { activeChatJid = '', replyTo } = options;
   const activeChatId = getUserIdFromJid(activeChatJid || options.activeChatId || '');
   const dispatch = useDispatch();
   const draftReplyToId = useSelector(state => state.draftData?.drafts?.[activeChatId]?.replyTo, shallowEqual);

   const isDraftMode = !('replyTo' in options);
   const replyToId = isDraftMode ? draftReplyToId : replyTo;

   const replyMessage = useRepliedMessageById(replyToId);

   const { clearReplyTo } = useDraft({ activeChatId });

   const handleHighlight = useCallback(
      msgId => {
         dispatch(setHighlightedMessageId({ chatId: activeChatId, msgId }));

         setTimeout(() => {
            dispatch(clearHighlightedMessageId({ chatId: activeChatId, msgId }));
         }, 500);
      },
      [dispatch, activeChatId],
   );

   const handleScrollToMessage = useCallback(async () => {
      if (!replyMessage?.msgId) return;
      const result = await scrollRef.current?.scrollToKey(replyMessage.msgId, { block: 0.3, smooth: true });
      if (result?.success) {
         handleHighlight(replyMessage.msgId);
      }
   }, [replyMessage, handleHighlight]);

   return {
      replyToId,
      replyMessage,
      handleScrollToMessage,
      handleHighlight,
      clearReplyTo,
   };
};
